<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="专家信息" name="first">
        <el-form ref="flowSpecialistAuditForm" :model="formData" class="full-width-input" :disable="readOnly"
                 :rules="rules"
                 style="width: 100%;"
                 label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
          <el-row :gutter="20">
            <!--            <el-col :span="6">-->
            <!--              <el-form-item label="个人名称" prop="Specialist.userName">-->
            <!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.userName"-->
            <!--                          :clearable="true" placeholder="个人名称"-->
            <!--                />-->
            <!--                <span class="input-item input-label" v-else>{{formData.Specialist.userName}}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="8" v-if="formData.Specialist.specialistNo">
              <el-form-item label="专家编号" prop="Specialist.specialistNo">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistNo"
                          placeholder="专家编号" readOnly
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.specialistNo}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="myLabel.specialistNameLabel" prop="Specialist.specialistName">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistName"
                          :clearable="true" placeholder="姓名"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.specialistName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="证件类型" prop="Specialist.documentType">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.documentType" :clearable="true" filterable
                           placeholder="证件类型" :loading="flowSpecialistAuditForm.documentType.impl.loading"
                           @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                           @change="onDocumentTypeValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.documentTypeDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号码" prop="Specialist.idCard">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.idCard"
                          :clearable="true" placeholder="身份证号码"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.idCard}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份" prop="Specialist.identity">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.identity" :clearable="true" filterable
                           placeholder="身份" :loading="flowSpecialistAuditForm.identity.impl.loading"
                           @visible-change="flowSpecialistAuditForm.identity.impl.onVisibleChange"
                           @change="onIdentityValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.identity.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.identityDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="籍贯" prop="Specialist.nativePlace">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.nativePlace"
                          :clearable="true" placeholder="籍贯"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.nativePlace}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="区级" prop="Specialist.isDistrict">-->
<!--                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.isDistrict" :clearable="true" filterable-->
<!--                           placeholder="区级" :loading="flowSpecialistAuditForm.isDistrict.impl.loading"-->
<!--                           @visible-change="flowSpecialistAuditForm.isDistrict.impl.onVisibleChange"-->
<!--                           @change="onIsDistrictValueChange">-->
<!--                  <el-option v-for="item in flowSpecialistAuditForm.isDistrict.impl.dropdownList" :key="item.id"-->
<!--                             :value="item.id" :label="item.name"-->
<!--                  />-->
<!--                </el-select>-->
<!--                <span class="input-item input-label" v-else>{{(formData.Specialist.isDistrictDictMap || {}).name}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="区级" prop="Specialist.isDistrict">
                <span class="input-item input-label">{{(formData.Specialist.isDistrictDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="政治面貌" prop="Specialist.politicalOutlook">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.politicalOutlook"
                          :clearable="true" placeholder="政治面貌"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.politicalOutlook}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别" prop="Specialist.gender">
                <el-select class="input-item" v-model="formData.Specialist.gender" :clearable="true" filterable
                           placeholder="性别" :loading="flowSpecialistAuditForm.gender.impl.loading"
                           @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange" v-if="!readOnly"
                           @change="onGenderValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.genderDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="出生日期" prop="Specialist.birthday">
                <el-date-picker class="input-item" v-if="!readOnly" v-model="formData.Specialist.birthday" :clearable="true"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date" align="left"
                                placeholder="出生日期"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.birthday}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产业" prop="Specialist.industryId">
                <el-cascader class="input-item" v-if="!readOnly" v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                             :clearable="true" :show-all-levels="false" placeholder="产业"
                             :props="{value: 'id', label: 'name', checkStrictly: true}"
                             @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                             @change="onIndustryIdValueChange"
                />
                <span class="input-item input-label" v-else>{{(formData.Specialist.industryIdDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="单位性质" prop="Specialist.companyProperties">-->
            <!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyProperties"-->
            <!--                          :clearable="true" placeholder="单位性质"-->
            <!--                />-->
            <!--                <span class="input-item input-label" v-else>{{formData.Specialist.companyProperties}}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="服务单位" prop="Specialist.serviceCompany">-->
            <!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.serviceCompany"-->
            <!--                          :clearable="true" placeholder="服务单位"-->
            <!--                />-->
            <!--                <span class="input-item input-label" v-else>{{formData.Specialist.serviceCompany}}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="工作单位属地" prop="Specialist.companyArea">-->
            <!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyArea"-->
            <!--                          :clearable="true" placeholder="工作单位属地"-->
            <!--                />-->
            <!--                <span class="input-item input-label" v-else>{{formData.Specialist.companyArea}}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
<!--            <el-col :span="8">-->
<!--              <el-form-item label="学术称号" prop="Specialist.academicTitle">-->
<!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.academicTitle"-->
<!--                          :clearable="true" placeholder="学术称号"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.academicTitle}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="8">-->
<!--              <el-form-item label="电子邮箱" prop="Specialist.email">-->
<!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.email"-->
<!--                          :clearable="true" placeholder="电子邮箱"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.email}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="8" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="学术称号" prop="Specialist.academicTitle">
                <span class="input-item input-label">{{formData.Specialist.academicTitle}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8" v-show="readOnly&&formData.Specialist.batch==='十二'">-->
<!--              <el-form-item label="电子邮箱" prop="Specialist.email">-->
<!--                <span class="input-item input-label">{{formData.Specialist.email}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="学历" prop="Specialist.education">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.education" :clearable="true" filterable
                           placeholder="学历" :loading="flowSpecialistAuditForm.education.impl.loading"
                           @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                           @change="onEducationValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.educationDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="学位" prop="Specialist.degreeLevel">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.degreeLevel" :clearable="true" filterable
                           placeholder="学位" :loading="flowSpecialistAuditForm.degreeLevel.impl.loading"
                           @visible-change="flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange"
                           @change="onDegreeLevelValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.degreeLevel.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.degreeLevelDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="职称" prop="Specialist.specialistTitleId">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistTitleId" :clearable="true" filterable
                           placeholder="职称" :loading="flowSpecialistAuditForm.specialistTitleId.impl.loading"
                           @visible-change="flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange"
                           @change="onSpecialistTitleIdValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.specialistTitleId.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.specialistTitleIdDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="Specialist.mobilePhone">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.mobilePhone"
                          :clearable="true" placeholder="联系电话"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.mobilePhone}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="工作单位" prop="Specialist.companyName">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyName"
                          :clearable="true" placeholder="工作单位"
                />

                <span class="input-item input-label" v-else>{{formData.Specialist.companyName}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8" >-->
<!--              <el-form-item label="统一社会信用代码" prop="Specialist.creditCode">-->
<!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.creditCode"-->
<!--                          :clearable="true" placeholder="统一社会信用代码"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.creditCode}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="单位性质" prop="Specialist.companyProperties">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyProperties"
                          :clearable="true" placeholder="单位性质"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.companyProperties}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作单位属地" prop="Specialist.companyArea">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyArea"
                          :clearable="true" placeholder="工作单位属地"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.companyArea}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="职位" prop="Specialist.companyPost">-->
<!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyPost"-->
<!--                          :clearable="true" placeholder="职位"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.companyPost}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="8" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="职位" prop="Specialist.companyPost">
                <span class="input-item input-label">{{formData.Specialist.companyPost}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="单位联系人" prop="Specialist.companyContacts">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyContacts"
                          :clearable="true" placeholder="单位联系人"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.companyContacts}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位联系电话" prop="Specialist.companyTel">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.companyTel"
                          :clearable="true" placeholder="单位联系电话"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.companyTel}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="8">-->
<!--              <el-form-item label="服务单位" prop="Specialist.serviceCompany">-->
<!--                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.serviceCompany"-->
<!--                          :clearable="true" placeholder="服务单位"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.serviceCompany}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
          </el-row>

          <el-row>
            <!--            <div  >-->
            <el-col :span="8">
              <el-form-item label="工作经费（元）" prop="Specialist.workingFunds">
<!--                <el-input-number class="input-item" v-if="!readOnly" v-model="formData.Specialist.workingFunds"-->
<!--                                 :clearable="true" placeholder="无经费填0"-->
<!--                />-->
                <el-radio-group v-model="formData.Specialist.workingFunds"  v-if="!readOnly">
                  <el-radio label="20000">20000</el-radio>
                  <el-radio label="0">0</el-radio>
                </el-radio-group>
                <span class="input-item input-label" v-else>{{formData.Specialist.workingFunds}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="拨付渠道" prop="Specialist.appropriateChannel"
                            v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                <el-select class="input-item" v-if="!readOnly" v-model="formData.Specialist.appropriateChannel" :clearable="true" filterable
                           placeholder="拨付渠道" :loading="flowSpecialistAuditForm.appropriateChannel.impl.loading"
                           @visible-change="flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange"
                           @change="onAppropriateChannelValueChange">
                  <el-option v-for="item in flowSpecialistAuditForm.appropriateChannel.impl.dropdownList" :key="item.id"
                             :value="item.id" :label="item.name"
                  />
                </el-select>
                <span class="input-item input-label" v-else>{{(formData.Specialist.appropriateChannelDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经费拨至单位" prop="Specialist.fundsToCompany"
                            v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.fundsToCompany"
                          :clearable="true" placeholder="经费拨至单位名称"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.fundsToCompany}}</span>
              </el-form-item>
            </el-col>
            <!--            </div>-->
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="myLabel.specialistAvatarLabel" prop="Specialist.specialistAvatar">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'specialistAvatar', asImage: true}"
                           :on-success="onSpecialistAvatarUploadSuccess"
                           :on-remove="onSpecialistAvatarRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.specialistAvatar.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.specialistAvatar.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.specialistAvatar, {id: formData.Specialist.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.specialistAvatar, {id: formData.Specialist.id, fieldName: 'specialistAvatar', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
<!--                  <img v-for="item in flowSpecialistAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
<!--                       class="table-cell-image" :src="item.url" />-->
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证正面" prop="Specialist.idPhoto">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'idPhoto', asImage: true}"
                           :on-success="onIdPhotoUploadSuccess"
                           :on-remove="onIdPhotoAvatarRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.idPhoto.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.idPhoto.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.idPhoto, {id: formData.Specialist.id,
                  fieldName: 'idPhoto', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.idPhoto, {id: formData.Specialist.id, fieldName: 'idPhoto', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
<!--                  <img v-for="item in flowSpecialistAuditForm.idPhoto.impl.fileList" :key="item.url"-->
<!--                       class="table-cell-image" :src="item.url" />-->
                </template>
              </el-form-item>
            </el-col>
<!--          </el-row>-->
<!--          <el-row>-->
            <el-col :span="8" >
              <el-form-item label="学历资料" prop="Specialist.educationalFile">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'educationalFile', asImage: true}"
                           :on-success="onEducationalFileUploadSuccess"
                           :on-remove="onEducationalFileRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.educationalFile.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.educationalFile.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.educationalFile, {id: formData.Specialist.id,
                  fieldName: 'educationalFile', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.educationalFile, {id: formData.Specialist.id, fieldName: 'educationalFile', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <!--                  <img v-for="item in flowSpecialistAuditForm.educationalFile.impl.fileList" :key="item.url"-->
                  <!--                       class="table-cell-image" :src="item.url" />-->
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="学位资料" prop="Specialist.degreeFiles">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'degreeFiles', asImage: true}"
                           :on-success="onDegreeFilesUploadSuccess"
                           :on-remove="onDegreeFilesRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.degreeFiles.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.degreeFiles.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.degreeFiles, {id: formData.Specialist.id,
                  fieldName: 'degreeFiles', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.degreeFiles, {id: formData.Specialist.id, fieldName: 'degreeFiles', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
<!--                  <img v-for="item in flowSpecialistAuditForm.degreeFiles.impl.fileList" :key="item.url"-->
<!--                       class="table-cell-image" :src="item.url" />-->
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="职称资料" prop="Specialist.positionalFiles">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'positionalFiles', asImage: true}"
                           :on-success="onPositionalFilesUploadSuccess"
                           :on-remove="onPositionalFilesRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.positionalFiles.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.positionalFiles.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.positionalFiles, {id: formData.Specialist.id,
                  fieldName: 'positionalFiles', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.positionalFiles, {id: formData.Specialist.id, fieldName: 'positionalFiles', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </template>
              </el-form-item>
            </el-col>

<!--          </el-row>-->
<!--          <el-row>-->
<!--                        <el-col :span="12" v-if="readOnly && formData.Specialist.batch==='十二'">-->
<!--                          <el-form-item label="职称资料" prop="Specialist.positionalFiles">-->

<!--                              <el-image v-for="item in parseUploadData(formData.Specialist.positionalFiles, {id: formData.Specialist.id,-->
<!--                              fieldName: 'positionalFiles', asImage: true})"-->
<!--                                        :preview-src-list="getPictureList(formData.Specialist.positionalFiles, {id: formData.Specialist.id, fieldName: 'positionalFiles', asImage: true})"-->
<!--                                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">-->
<!--                                <div slot="error" class="table-cell-image">-->
<!--                                  <i class="el-icon-picture-outline"></i>-->
<!--                                </div>-->
<!--                              </el-image>-->

<!--                          </el-form-item>-->
<!--                        </el-col>-->

            <el-col :span="8">
              <el-form-item label="三方协议书" prop="SpecialistHis.contractFiles">
                <el-upload name="uploadFile" :headers="getUploadHeaders" multiple v-if="!readOnly"
                           :action="getUploadActionUrl('/admin/app/specialistHis/upload')"
                           :data="{fieldName: 'contractFiles', asImage: false}"
                           :on-success="onContractFilesUploadSuccess"
                           :on-remove="onContractFilesRemoveFile"
                           :on-error="onUploadError" :on-exceed="onUploadLimit"
                           :limit="signContractWin.contractFiles.impl.maxCount"
                           :file-list="signContractWin.contractFiles.impl.fileList"
                           :show-file-list="false"
                >
                  <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>

                </el-upload>
                <div v-if="signContractWin.contractFiles.impl.fileList && signContractWin.contractFiles.impl.fileList[0] != null" style="position: relative">
                  <div v-for="item in signContractWin.contractFiles.impl.fileList" :key="item.url" style="display: inline-flex">
                    <div> {{item.name}}</div>
                    <div style="margin-left: 15px">
                      <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                      <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                      <el-button type="primary" v-if="!readOnly" @click="onContractFilesRemoveFile(null,null)">删除
                      </el-button>
                    </div>

                  </div>
                </div>
                <template v-else>
                  <a v-for="item in signContractWin.contractFiles.impl.fileList" :key="item.url"
                     href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                    {{item.name}}
                  </a>

                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"  v-if="readOnly">
              <el-form-item label="类型" prop="Specialist.specialistType">
                <el-radio-group class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistType"
                                @change="onSpecialistTypeValueChange"
                >
                  <el-radio v-for="item in flowSpecialistAuditForm.specialistType.impl.dropdownList" :key="item.id"
                            :label="item.id"
                  >
                    {{item.name}}
                  </el-radio>
                </el-radio-group>
                <span class="input-item input-label" v-else>{{(formData.Specialist.specialistTypeDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="formData.Specialist.specialistType=='2'">
              <el-form-item label="团队名称" prop="Specialist.teamName">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.teamName"
                          :clearable="true" placeholder="团队名称"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.teamName}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="6" v-show="formData.Specialist.specialistType=='3'">
              <el-form-item label="法人识别号" prop="Specialist.identityCardNo">
                <el-input class="input-item" v-if="!readOnly" v-model="formData.Specialist.identityCardNo"
                          :clearable="true" placeholder="法人识别号"
                />
                <span class="input-item input-label" v-else>{{formData.Specialist.identityCardNo}}</span>
              </el-form-item>
            </el-col>

<!--            <el-col :span="24" v-show="formData.Specialist.specialistType!='3'">-->
<!--              <el-form-item label="专业领域" prop="Specialist.specializedField">-->
<!--                <el-input class="input-item" v-model="formData.Specialist.specializedField"-->
<!--                          type="textarea" v-if="!readOnly"-->
<!--                          :autosize="{minRows: 4, maxRows: 8}"-->
<!--                          :clearable="true" placeholder="请输入专业领域"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.Specialist.specializedField}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24" v-show="readOnly&&formData.Specialist.batch==='十二'&&formData.Specialist.specialistType!='3'">
              <el-form-item label="专业领域" prop="Specialist.specializedField">
                <span class="input-item input-label" >{{ formData.Specialist.specializedField }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="myLabel.specialistSpecialLabel" prop="Specialist.specialistSpecial">
                <rich-editor ref="specialistSpecial" class="input-item" v-if="!readOnly" v-model="formData.Specialist.specialistSpecial" />

                <div class="input-item" v-else v-html="formData.Specialist.specialistSpecial" />
              </el-form-item>
            </el-col>

<!--            <el-col :span="24" v-show="true">-->
<!--              <el-form-item label="附件" prop="Specialist.otherFiles">-->
<!--                <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--                           :action="getUploadActionUrl('/admin/app/specialist/upload')"-->
<!--                           :data="{fieldName: 'otherFiles', asImage: false}"-->
<!--                           :on-success="onOtherFilesUploadSuccess"-->
<!--                           :on-remove="onOtherFilesRemoveFile"-->
<!--                           :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--                           :limit="flowSpecialistAuditForm.otherFiles.impl.maxCount"-->
<!--                           :file-list="flowSpecialistAuditForm.otherFiles.impl.fileList"-->
<!--                           :show-file-list="false">-->
<!--                  <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--                </el-upload>-->
<!--                <div v-if="flowSpecialistAuditForm.otherFiles.impl.fileList && flowSpecialistAuditForm.otherFiles.impl.fileList[0] != null" style="position: relative">-->
<!--                  <div v-for="(item,index) in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"-->
<!--                       style="display:flex;margin-top: 5px;">-->
<!--                    <div> {{item.name}}</div>-->
<!--                    <div style="margin-left: 15px;display: inline-flex">-->

<!--                      <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>-->
<!--                      <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>-->
<!--                      <el-button type="primary" v-if="!readOnly"-->
<!--                                 @click="deleteOtherFiles(item,flowSpecialistAuditForm.otherFiles.impl.fileList,index)">删除</el-button>-->
<!--                    </div>-->

<!--                  </div>-->
<!--                </div>-->
<!--                <template v-else>-->
<!--                  <a v-for="item in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"-->
<!--                     href="javascript:void(0);" @click="previewFile(item.url, item.filename)">-->
<!--                    {{item.name}}-->
<!--                  </a>-->
<!--                </template>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24" v-show="formData.Specialist.specialistType=='2'">
              <el-row type="flex" justify="space-between" align="middle" style="margin-bottom: 15px;">
                <div class="table-title" style="padding-left: 5px; border-left: 3px solid #409EFF;">成员信息</div>
                <!-- 表格操作 -->
                <div>
                </div>
              </el-row>
            </el-col>
            <el-col :span="24" v-show="formData.Specialist.specialistType=='2'">
              <filter-box :item-width="350">
                <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                           @click="addSpecialistMember()" v-if="!readOnly" >
                  新增成员
                </el-button>
              </filter-box>
            </el-col>
            <template v-show="formData.Specialist.specialistType=='2'">
              <el-table ref="specialistMember" :data="flowSpecialistAuditForm.SpecialistMember.impl.dataList" :size="defaultFormItemSize" @sort-change="flowSpecialistAuditForm.SpecialistMember.impl.onSortChange"
                        header-cell-class-name="table-header-gray" v-show="formData.Specialist.specialistType=='2'"
              >
                <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="flowSpecialistAuditForm.SpecialistMember.impl.getTableIndex" />
                <el-table-column label="专家名称" prop="specialistName">
                </el-table-column>
                <el-table-column label="专家照片" min-width="100px">
                  <template slot-scope="scope">
                    <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                              :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                              class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                      <div slot="error" class="table-cell-image">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column label="联系电话" prop="mobilePhone">
                </el-table-column>
                <el-table-column label="产业" prop="industryName">
                </el-table-column>
                <el-table-column label="职称" prop="specialistTitle">
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click.stop="onDeleteClick(scope.row, scope.$index)" type="text" :size="defaultFormItemSize" v-if="!readOnly">
                      删除
                    </el-button>
                    <el-button @click.stop="onSpecialistMemberEditClick(scope.row, scope.$index)" type="text" :size="defaultFormItemSize" v-if="!readOnly">
                      编辑
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-row type="flex" justify="end" style="margin-top: 10px;" v-show="formData.Specialist.specialistType=='2'">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="currentPage"
                               :page-sizes="pageSizes"
                               :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper"
                               :total="flowSpecialistAuditForm.SpecialistMember.impl.totalCount">
                </el-pagination>
              </el-row>
            </template>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="服务对象" prop="SpecialistHis.serviceObjectName">
                <el-input class="input-item" v-model="formData.SpecialistHis.serviceObjectName" v-if="!readOnly"
                          :clearable="true" placeholder="服务对象"
                />
                <span class="input-item input-label" v-else>{{formData.SpecialistHis.serviceObjectName}}</span>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地区" prop="SpecialistHis.serviceAreaId">
                <el-cascader class="input-item" v-if="!readOnly" v-model="formData.SpecialistHis.serviceAreaId"
                             :options="signContractWin.serviceAreaId.impl.dropdownList" filterable ref="serviceAreaIdCas"
                             :clearable="true" :show-all-levels="true" placeholder="所在地区"
                             :props="{value: 'id', label: 'name', checkStrictly: true}"
                             @visible-change="signContractWin.serviceAreaId.impl.onVisibleChange"
                             @change="onServiceAreaIdValueChange"
                />
                <span class="input-item input-label" v-else>{{(formData.SpecialistHis.serviceAreaIdDictMap || {}).name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务详细地址" >
                <el-input class="input-item" v-model="formData.SpecialistHis.serviceAddress" v-if="!readOnly"
                          :clearable="true" placeholder="服务详细地址"
                />
                <span class="input-item input-label" v-else>{{formData.SpecialistHis.serviceAddress}}</span>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="SpecialistHis.contactsUser">
                <el-input class="input-item" v-model="formData.SpecialistHis.contactsUser" v-if="!readOnly"
                          :clearable="true" placeholder="请输入服务对象联系人"
                />
                <span class="input-item input-label" v-else>{{formData.SpecialistHis.contactsUser}}</span>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="SpecialistHis.contactsUserTel">
                <el-input class="input-item" v-model="formData.SpecialistHis.contactsUserTel" v-if="!readOnly"
                          :clearable="true" placeholder="请输入服务对象联系人电话"
                />
                <span class="input-item input-label" v-else>{{formData.SpecialistHis.contactsUserTel}}</span>

              </el-form-item>
            </el-col>
<!--            <el-col :span="24">-->
<!--              <el-form-item label="主营业务" prop="SpecialistHis.mainBusiness">-->
<!--                <el-input class="input-item" v-model="formData.SpecialistHis.mainBusiness" v-if="!readOnly"-->
<!--                          type="textarea"-->
<!--                          :autosize="{minRows: 4, maxRows: 8}"-->
<!--                          :clearable="true" placeholder="请填写服务对象主营业务"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.SpecialistHis.mainBusiness}}</span>-->

            <el-col :span="24" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="主营业务" prop="Specialist.mainBusiness">
                <span class="input-item input-label" >{{ formData.Specialist.mainBusiness }}</span>
              </el-form-item>
            </el-col>

<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :span="12">-->
<!--              <el-form-item label="服务期" prop="SpecialistHis.signYear">-->
<!--                <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYear" :clearable="true" v-if="!readOnly"-->
<!--                                format="yyyy"-->
<!--                                value-format="yyyy-MM-dd"-->
<!--                                type="year" align="left"-->
<!--                                placeholder="服务期"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formatDateByStatsType(formData.SpecialistHis.signYear, 'year')}}</span>-->

<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="12">
              <el-form-item label="服务期起始" prop="SpecialistHis.signYearStart">
                <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearStart" :clearable="true" v-if="!readOnly"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date" align="left"
                                placeholder="服务期起始"
                />
                <span class="input-item input-label" v-else>{{formatDateByStatsType(formData.SpecialistHis.signYearStart,
                  'date')}}</span>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务期结束" prop="SpecialistHis.signYearEnd">
                <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearEnd" :clearable="true" v-if="!readOnly"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date" align="left"
                                placeholder="服务期结束"
                />
                <span class="input-item input-label" v-else>{{formatDateByStatsType(formData.SpecialistHis.signYearEnd,
                'date')}}</span>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="服务对象技术需求（100字以内）" prop="SpecialistHis.serviceUserRequirement">
                <el-input class="input-item" v-model="formData.SpecialistHis.serviceUserRequirement" v-if="!readOnly"
                          :clearable="true" placeholder="（受援单位提出需要解决的技术问题等）"
                />
                <span class="input-item input-label" v-else>{{formData.SpecialistHis.serviceUserRequirement}}</span>

              </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="营业执照" prop="Specialist.servicePhoto">
                <el-upload v-if="!readOnly"
                           class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                           :action="getUploadActionUrl('/admin/app/specialist/upload')"
                           :data="{fieldName: 'servicePhoto', asImage: true}"
                           :on-success="onServicePhotoUploadSuccess"
                           :on-remove="onServicePhotoRemoveFile"
                           :before-upload="pictureFile"
                           :on-error="onUploadError"
                           :show-file-list="true"
                           :on-preview="handlePreview"
                           :limit="flowSpecialistAuditForm.servicePhoto.impl.maxCount"
                           :on-exceed="onUploadLimit"
                           :file-list="flowSpecialistAuditForm.servicePhoto.impl.fileList"
                           list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <template v-else>
                  <el-image v-for="item in parseUploadData(formData.Specialist.servicePhoto, {id: formData.Specialist.id,
                  fieldName: 'servicePhoto', asImage: true})"
                            :preview-src-list="getPictureList(formData.Specialist.servicePhoto, {id: formData.Specialist.id, fieldName: 'servicePhoto', asImage: true})"
                            class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <!--                  <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
                  <!--                       class="table-cell-image" :src="item.url" />-->
                </template>
              </el-form-item>
            </el-col>

<!--            <el-col :span="24">-->
<!--              <el-form-item label="服务方式" prop="SpecialistHis.serviceType">-->
<!--                <el-input class="input-item" v-model="formData.SpecialistHis.serviceType" v-if="!readOnly"-->
<!--                          type="textarea"-->
<!--                          :autosize="{minRows: 4, maxRows: 8}"-->
<!--                          :clearable="true" placeholder="（根据受援单位需求，科技人员可提供的服务方式：专业技术服务，与农民结成利益共同体、创办领办农民合作社、企业等，推进农村科技创新创业，培养本土科技人才等。）"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.SpecialistHis.serviceType}}</span>-->

<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="24" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="服务方式" prop="Specialist.serviceType">
                <span class="input-item input-label" >{{ formData.Specialist.serviceType }}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="24">-->
<!--              <el-form-item label="服务内容" prop="SpecialistHis.serviceContent">-->
<!--                <el-input class="input-item" v-model="formData.SpecialistHis.serviceContent" v-if="!readOnly"-->
<!--                          type="textarea"-->
<!--                          :autosize="{minRows: 4, maxRows: 8}"-->
<!--                          :clearable="true" placeholder="（根据受援单位需求开展的服务内容、预计成效等）"-->
<!--                />-->
<!--                <span class="input-item input-label" v-else>{{formData.SpecialistHis.serviceContent}}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="服务内容" prop="Specialist.serviceContent">
                <span class="input-item input-label" >{{ formData.Specialist.serviceContent }}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :span="24">-->
<!--              <el-form-item label="服务其他附件" prop="SpecialistHis.attachedFiles">-->
<!--                <el-upload name="uploadFile" :headers="getUploadHeaders" multiple v-if="!readOnly"-->
<!--                           :action="getUploadActionUrl('/admin/app/specialistHis/upload')"-->
<!--                           :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--                           :on-success="onAttachedFilesUploadSuccess"-->
<!--                           :on-remove="onAttachedFilesRemoveFile"-->
<!--                           :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--                           :limit="signContractWin.attachedFiles.impl.maxCount"-->
<!--                           :file-list="signContractWin.attachedFiles.impl.fileList"-->
<!--                           :show-file-list="false">-->
<!--                  <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--                </el-upload>-->
<!--                <div v-if="signContractWin.attachedFiles.impl.fileList && signContractWin.attachedFiles.impl.fileList[0] != null" style="position: relative">-->
<!--                  <div v-for="(item,index) in signContractWin.attachedFiles.impl.fileList" :key="item.url"-->
<!--                       style="display:flex;margin-top: 5px;">-->
<!--                    <div> {{item.name}}</div>-->
<!--                    <div style="margin-left: 15px;display: inline-flex">-->

<!--                      <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>-->
<!--                      <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>-->
<!--                      <el-button type="primary" v-if="!readOnly"-->
<!--                                 @click="deleteAttachedFiles(item,signContractWin.attachedFiles.impl.fileList,index)">删除</el-button>-->
<!--                    </div>-->

<!--                  </div>-->
<!--                </div>-->
<!--                <template v-else>-->
<!--                  <a v-for="item in signContractWin.attachedFiles.impl.fileList" :key="item.url"-->
<!--                     href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                    {{item.name}}-->
<!--                  </a>-->
<!--                </template>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="24" v-show="readOnly&&formData.Specialist.batch==='十二'">
              <el-form-item label="服务其他附件" prop="Specialist.attachedFiles">
                <a v-for="item in signContractWin.attachedFiles.impl.fileList" :key="item.url"
                   href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                  {{ item.name }}
                </a>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: center;" v-if="!isStartFlow && !readOnly">
            <el-button @click="saveUpdate" type="primary">保存修改</el-button>
          </el-row>
        </el-form>
      </el-tab-pane>
<!--      <el-tab-pane label="对接记录" name="second" v-if="this.getUserInfo.roleIds&&!this.getUserInfo.roleIds.includes('1526389453763907584')" >-->
<!--        <RequirementRelateHis v-if="showSecond" :specialistIds="formData.Specialist.id"></RequirementRelateHis>-->
<!--      </el-tab-pane>-->
      <el-tab-pane label="申报记录" name="third">
        <SpecialistHisT v-if="showSecond" :specialistId="formData.Specialist.specialId"></SpecialistHisT>

      </el-tab-pane>
      <el-tab-pane label="审批记录" name="four" v-if="processInstanceId" >
        <SpecialistAuditHis v-if="showSecond" :processInstanceId="processInstanceId"></SpecialistAuditHis>
      </el-tab-pane>
      <el-tab-pane label="科特派证书" name="five" v-if="this.getUserInfo.roleIds&&!this.getUserInfo.roleIds.includes('1526389453763907584')" >
        <SpecialistCertificate v-if="showSecond" :specialistId="formData.Specialist.specialId"></SpecialistCertificate>
      </el-tab-pane>
      <!--      <el-tab-pane label="定时任务补偿" name="fourth"></el-tab-pane>-->
    </el-tabs>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
    <el-dialog
      title="各相关单位:"
      :visible.sync="dialogVisible"
      width="40%">
      <span style="font-size: 20px;    letter-spacing: 1pt;    line-height: 25px;">科技特派员工作经费:专项用于科技特派员在受援地的设备费、材料费、测试化验加工费、交通差旅费用、保险和培训费用，不得用于其他支出，
        科技特派员须在工作单位或科技特派员服务单位报账。工作单位或科技特派员服务单位须单独设账，独立核算，专款专用，严禁截留挪用。</span>
      <div style="font-size: 20px;float:right;margin-top: 10px">
        <span>延平区发展改革和科技局</span>
        <!--        <div>2022年10月14日</div>-->
      </div>

      <div slot="footer" class="dialog-footer" style="margin-bottom: 20px">
        <el-checkbox v-model="checked" style="float: left" >我同意</el-checkbox>
        <el-button  type="primary" v-if="checked && isStartFlow " @click="beforeHandlerStart">确 定</el-button>
        <el-button  type="primary" v-if="checked && !isStartFlow "  @click="beforeHandlerOperation">确
          定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SpecialistController, DictionaryController, RequirementController, SpecialistHisController, SpecialistInfoController} from '@/api';
import { FlowOperationController } from '@/api/flowController.js';
import specialistMemberEdit from '../../../specialist/specialistMemberEdit';
import specialistMemberForm from '../../../specialist/specialistMemberForm';
import RequirementRelateHis from '@/components/RequirementRelateHis';
import SpecialistHisT from '@/components/SpecialistHis';
import SpecialistAuditHis from '@/components/SpecialistAuditHis';
import SpecialistCertificate from '@/components/SpecialistCertificate';

import { validateSfz } from '@/utils/validateSfz.js';
const processDefinitionKey = 'flowSpecialistInfo';

export default {
  components: {
    RequirementRelateHis,
    SpecialistHisT,
    SpecialistAuditHis,
    SpecialistCertificate,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  name: 'flowSpecialistInfoForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      checked: false,
      dialogVisible: false,
      showSecond: false,
      activeName: 'first',
      // 默认显示第几页
      currentPage: 1,
      // 总条数
      totalCount: 1,
      // 个数选择器
      pageSizes: [10, 15, 20, 30],
      // 默认每页显示的条数
      PageSize: 10,
      fit: 'scale-down',
      formData: {
        Specialist: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistType: '1',
          specialistName: undefined,
          teamName: undefined,
          specialistAvatar: undefined,
          mobilePhone: undefined,
          gender: undefined,
          specialistSpecial: undefined,
          companyName: undefined,
          specialistTitle: undefined,
          companyTel: undefined,
          birthday: undefined,
          educationalFile: undefined,
          companyContacts: undefined,
          companyPost: undefined,
          degreeFiles: undefined,
          specialistTitleId: undefined,
          companyContactsTel: undefined,
          degreeLevel: undefined,
          positionalFiles: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          hotFlag: undefined,
          userId: undefined,
          areaId: undefined,
          hotScore: undefined,
          industryName: undefined,
          relateId: undefined,
          areaName: undefined,
          industryId: undefined,
          specializedField: undefined,
          starFlag: undefined,
          stationIds: undefined,
          associationStation: undefined,
          identityCardNo: undefined,
          mainBusiness: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          serviceObjectName: undefined,
          signYear: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          serviceUserRequirement: undefined,
          isDatasourceInit: false,
          specialistMemberList: [],
          servicePhoto: undefined
        },
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false,
          serviceAddress: undefined,
          signYearStart: '2025-06-30',
          signYearEnd: '2027-06-30'
        }
      },
      rules: {
        'Specialist.specialistName': [
          {required: true, message: '请输入姓名', trigger: 'change'}
        ],
        'Specialist.birthday': [
          {required: true, message: '请选择出生日期', trigger: 'change'}
        ],
        'Specialist.industryId': [
          {required: true, message: '请选择专业领域', trigger: 'change'}
        ],
        'Specialist.mobilePhone': [
          {required: true, message: '请输入联系电话', trigger: 'change'}
        ],

        // 'Specialist.teamName': [
        //   {required: true, message: '请输入团队名称', trigger: 'change'}
        // ],
        // 'Specialist.identityCardNo': [
        //   {required: true, message: '请输入法人识别号', trigger: 'change'}
        // ],
        'Specialist.idCard': [
          {required: true, validator: validateSfz, trigger: 'change'}
        ],
        'Specialist.companyName': [
          {required: true, message: '请输入工作单位', trigger: 'change'}
        ],
        // 'Specialist.companyPost': [
        //   {required: true, message: '请输入职位', trigger: 'change'}
        // ],
        'Specialist.companyContacts': [
          {required: true, message: '请输入单位联系人', trigger: 'change'}
        ],
        'Specialist.companyTel': [
          {required: true, message: '请输入单位联系电话', trigger: 'change'}
        ],
        'Specialist.degreeLevel': [
          {required: true, message: '请选择学位', trigger: 'change'}
        ],
        'Specialist.specialistTitleId': [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        // 'Specialist.isDistrict': [
        //   {required: true, message: '请选择是否区级', trigger: 'change'}
        // ],
        'Specialist.workingFunds': [
          {required: true, message: '请输入工作经费', trigger: 'change'}
        ],
        'Specialist.appropriateChannel': [
          {required: true, message: '请输入拨付渠道', trigger: 'change'}
        ],
        'Specialist.fundsToCompany': [
          {required: true, message: '请输入经费拨至单位名称', trigger: 'change'}
        ],
        'Specialist.education': [
          {required: true, message: '请输入学历', trigger: 'change'}
        ],
        'Specialist.documentType': [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        'Specialist.specialistType': [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        'Specialist.nativePlace': [
          {required: true, message: '请输入籍贯', trigger: 'change'}
        ],
        'Specialist.identity': [
          {required: true, message: '请输入身份', trigger: 'change'}
        ],
        'Specialist.nation': [
          {required: true, message: '请输入民族', trigger: 'change'}
        ],
        'Specialist.politicalOutlook': [
          {required: true, message: '请输入政治面貌', trigger: 'change'}
        ],
        'SpecialistHis.serviceObjectName': [
          {required: true, message: '请输入服务对象', trigger: 'change'}
        ],
        // 'Specialist.serviceCompany': [
        //   {required: true, message: '请输入服务单位', trigger: 'change'}
        // ],
        'Specialist.companyArea': [
          {required: true, message: '请输入工作单位属地', trigger: 'change'}
        ],
        'Specialist.gender': [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        // 'Specialist.companyProperties': [
        //   {required: true, message: '请输入单位性质', trigger: 'change'}
        // ],
        'Specialist.specialistSpecial': [
          {required: true, message: '请输入简介'}
        ],
        'Specialist.educationalFile': [
          {required: true, message: '请上传学历资料', trigger: 'change'}
        ],
        'Specialist.degreeFiles': [
          {required: true, message: '请上传学位资料', trigger: 'change'}
        ],
        // 'Specialist.positionalFiles': [
        //   {required: true, message: '请上传职称资料', trigger: 'change'}
        // ],
        'Specialist.servicePhoto': [
          {required: false, message: '请上传服务单位营业执照'}
        ],
        'Specialist.specialistAvatar': [
          {required: true, message: '请上传照片', trigger: 'change'}
        ],
        'Specialist.idPhoto': [
          {required: true, message: '请上传身份证正面'}
        ],
        'Specialist.creditCode': [
          {required: true, message: '统一社会信用代码', trigger: 'change'}
        ],
        'SpecialistHis.serviceAreaId': [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        'SpecialistHis.contactsUser': [
          {required: true, message: '请输入服务对象联系人', trigger: 'change'}
        ],
        'SpecialistHis.contactsUserTel': [
          {required: true, message: '请输入服务对象联系人电话', trigger: 'change'}
        ],

        // 'SpecialistHis.mainBusiness': [
        //   {required: true, message: '请填写服务对象主营业务', trigger: 'change'}
        // ],
        // 'SpecialistHis.identityCardNo': [
        //   {required: true, message: '请输入法人识别号', trigger: 'change'}
        // ],
        'SpecialistHis.contractFiles': [
          {required: true, message: '请上传三方协议', trigger: 'change'}
        ],
        // 'SpecialistHis.signYear': [
        //   {required: true, message: '请选择服务期', trigger: 'change'}
        // ],
        'SpecialistHis.signYearStart': [
          {required: true, message: '请选择服务期起始', trigger: 'change'}
        ],
        'SpecialistHis.signYearEnd': [
          {required: true, message: '请选择服务期结束', trigger: 'change'}
        ]

      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      flowSpecialistAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        appropriateChannel: {
          impl: new DropdownWidget(this.loadAppropriateChannelDropdownList)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        specialistAvatar: {
          impl: new UploadWidget(1)
        },
        idPhoto: {
          impl: new UploadWidget(1)
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        degreeLevel: {
          impl: new DropdownWidget(this.loadDegreeLevelDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        educationalFile: {
          impl: new UploadWidget(1)
        },
        degreeFiles: {
          impl: new UploadWidget(1)
        },
        positionalFiles: {
          impl: new UploadWidget(1)
        },
        servicePhoto: {
          impl: new UploadWidget(1)
        },
        // serviceAreaId: {
        //   impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
        //   value: []
        // },
        otherFiles: {
          impl: new UploadWidget(10)
        },
        stationIds: {
          impl: new DropdownWidget(this.loadStationIdsDropdownList)
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        hotFlag: {
          impl: new DropdownWidget(this.loadHotFlagDropdownList)
        },
        starFlag: {
          impl: new DropdownWidget(this.loadStarFlagDropdownList)
        },
        SpecialistMember: {
          impl: new TableWidget(this.loadSpecialistMemberWidgetData, this.loadSpecialistMemberVerify, true, false)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        identity: {
          impl: new DropdownWidget(this.loadIdentityDropdownList)
        },
        isDistrict: {
          impl: new DropdownWidget(this.loadIsDistrictDropdownList)
        },
        isInit: false
      },
      myLabel: {
        specialistNameLabel: '姓名',
        specialistAvatarLabel: '照片',
        specialistSpecialLabel: '专家简介、技术特长及服务内容（不超过100字）',
        identityCardNoLabel: '身份证号'
      },
      myFlag: {
        birthdayFlag: true
      },
      operation: {},
      copyItemList: [],
      signContractWin: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceAreaId: {
          impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        contractFiles: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(10)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },

  methods: {
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange (val) {
      // 改变默认的页数
      this.currentPage = val
    },
    // 启动流程
    handlerStart (operation, copyItemList) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      if (this.formData.Specialist.specialistType === '2' && this.formData.Specialist.specialistMemberList.length === 0) {
        this.$message.error('请新增团队成员信息！');
      } else if (this.formData.Specialist.specialistSpecial === undefined || this.formData.Specialist.specialistSpecial === '<p><br></p>') {
        this.$message.error('请填写' + this.myLabel.specialistSpecialLabel);
      } else {
        this.$refs.flowSpecialistAuditForm.validate(valid => {
          if (!valid) {
            this.$message.error('信息不完整，请检查！');
          } else {
            this.dialogVisible = true
            this.operation = operation
            this.copyItemList = copyItemList
          }
        })

        // this.beforeHandlerStart(operation, copyItemList)
      }
    },
    beforeHandlerStart () {
      let operation = this.operation
      let copyItemList = this.copyItemList
      this.dialogVisible = false
      // return new Promise((resolve, reject) => {
      this.$refs.flowSpecialistAuditForm.validate(valid => {
        if (!valid) {
          this.$message.error('信息不完整，请检查！')
          return;
        }
        // 整理数据
        this.formData.SpecialistHis.specialistName = this.formData.Specialist.specialistName

        this.preHandlerOperation(operation, true).then(res => {
          let formData = this.getMasterData(operation.type, (res || {}).assignee);
          return SpecialistInfoController.startAndTakeUserTaskFlowSpecialistInfo(this, {
            processDefinitionKey: processDefinitionKey,
            taskVariableData: {
              ...formData.taskVariableData,
              latestApprovalStatus: operation.latestApprovalStatus
            },
            flowTaskCommentDto: {
              approvalType: operation.type
            },
            specialistInfoDto: {
              ...formData.masterData,
              // specialId: this.formData.Specialist.id,
              id: null
            },
            specialistHisDto: this.formData.SpecialistHis,
            ...formData.relationData,
            copyData: (copyItemList || []).reduce((retObj, item) => {
              retObj[item.type] = item.id;
              return retObj;
            }, {})
          });
        }).then(res => {
          setTimeout(() => {
            this.$message.success('启动成功！');
          }, 100)
          // this.$router.replace('flowSpecialistAuditList');
          this.$router.go(-1);
          // resolve();
        }).catch(e => {
          // reject(e);
        });
      });
      // });
    },
    // 保存修改
    saveUpdate () {
      // let formData = this.getMasterData(this.operation.type, (res || {}).assignee);
      let params = {
        specialistInfoDto: {
          ...this.formData.Specialist
        },
        specialistHisDto: this.formData.SpecialistHis
      }

      this.$refs.flowSpecialistAuditForm.validate(valid => {
        if (!valid) {
          this.$message.error('信息不完整，请检查！');
        } else {
          SpecialistInfoController.update(this, params).then(res => {
            this.$message.success('修改成功！');
          })
        }
      })
    },
    // 流程操作
    handlerOperation (operation, copyItemList) {
      return new Promise((resolve, reject) => {
        if (this.formData.Specialist.specialistType === '2' && this.formData.Specialist.specialistMemberList.length === 0) {
          this.$message.error('请新增团队成员信息！');
        } else if (this.formData.Specialist.specialistSpecial === undefined || this.formData.Specialist.specialistSpecial === '<p><br></p>') {
          this.$message.error('请填写' + this.myLabel.specialistSpecialLabel);
        } else {
          this.$refs.flowSpecialistAuditForm.validate(valid => {
            if (!valid && operation.type !== this.SysFlowTaskOperationType.REJECT && operation.type !==
              this.SysFlowTaskOperationType.REJECT_TO_START) {
              this.$message.error('信息不完整，请检查！')
              return reject();
            }
            this.operation = operation
            this.copyItemList = copyItemList
            if (this.isDraft) {
              this.dialogVisible = true
            } else {
              this.beforeHandlerOperation()
            }
          });
        }
      });
    },
    // 保存草稿
    beforeHandlerOperation () {
      let operation = this.operation
      let copyItemList = this.copyItemList
      this.dialogVisible = false
      // return new Promise((resolve, reject) => {
      this.preHandlerOperation(operation, this.isDraft).then(res => {
        // 加签、减签操作
        if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
          return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
        }
        // 驳回操作
        if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
          return FlowOperationController.rejectRuntimeTask(this, {
            processInstanceId: this.processInstanceId,
            taskId: this.taskId,
            targetTaskKey: (res || {}).targetTaskKey,
            taskComment: (res || {}).message,
            taskVariableData: {
              latestApprovalStatus: operation.latestApprovalStatus
            }
          });
        }
        // 驳回到起点
        if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
          return FlowOperationController.rejectToStartUserTask(this, {
            processInstanceId: this.processInstanceId,
            taskId: this.taskId,
            taskComment: (res || {}).message,
            taskVariableData: {
              latestApprovalStatus: operation.latestApprovalStatus
            }
          });
        }
        // 撤销操作
        if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
          this.$confirm('是否撤销此任务？').then(res => {
            return FlowOperationController.revokeHistoricTask(this, {
              processInstanceId: this.processInstanceId,
              taskId: this.taskId,
              taskComment: '任务处理人撤销任务',
              taskVariableData: {
                latestApprovalStatus: operation.latestApprovalStatus
              }
            });
          })
          //   .catch(e => {
          //   return Promise.reject(e);
          // });
          return
        }
        let formData = this.getMasterData(operation.type, (res || {}).assignee);
        let params = {
          taskId: this.taskId || this.draftTaskId,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          flowTaskCommentDto: {
            taskComment: (res || {}).message,
            approvalType: operation.type,
            delegateAssginee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
          },
          taskVariableData: {
            ...formData.taskVariableData,
            latestApprovalStatus: operation.latestApprovalStatus
          },
          copyData: (copyItemList || []).reduce((retObj, item) => {
            retObj[item.type] = item.id;
            return retObj;
          }, {})
        }
        // 非只读状态下，提交修改数据
        if (!this.readOnly) {
          // 主表数据
          params.specialistInfoDto = {
            ...formData.masterData
          };
          params.specialistHisDto = this.formData.SpecialistHis;
          // 关联数据
          params = {
            ...params,
            ...formData.relationData
          };
        }

        return SpecialistInfoController.submitUserTaskFlowSpecialistInfo(this, params);
      }).then(res => {
        this.reloadMessage(this);
        if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
          this.$message.success(operation.label + '成功！');
        }
        this.$router.go(-1);
        // resolve();
      }).catch(e => {
        console.log(e);
      });
      // });
    },
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          specialistInfoDto: {
            ...formData.masterData
          },
          specialistHisDto: this.formData.SpecialistHis,
          ...formData.relationData
        }
        SpecialistInfoController.startAndSaveDraftFlowSpecialistInfo(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          this.$router.go(-1);
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};
      if (this.formData.Specialist.specialistType !== '2') {
        this.formData.Specialist.specialistMemberList = []
      }

      this.formData.SpecialistHis.signYearStart = '2025-06-30'
      this.formData.SpecialistHis.signYearEnd = '2027-06-30'

      this.formData.Specialist.signYearStart = this.formData.SpecialistHis.signYearStart
      this.formData.Specialist.signYearEnd = this.formData.SpecialistHis.signYearEnd
      return {
        masterData: {
          ...this.formData.Specialist
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.Specialist[item.variableName];
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee[0] : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      let that = this
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? SpecialistInfoController.viewTaskBusinessDataFlowSpecialistInfo(this, params) : SpecialistInfoController.viewHistoricTaskBusinessDataFlowSpecialistInfo(this, params)
        }
        httpCall.then(res => {
          let dataForm = { ...res.data };
          this.onSpecialistTypeValueChange(dataForm.specialistType)
          this.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});

          this.flowSpecialistAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
          if (dataForm.specialistAvatar) {
            let str = JSON.parse(dataForm.specialistAvatar)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.specialistAvatar = JSON.stringify(str)

            let specialistAvatarDownloadParams = {
              id: dataForm.id,
              fieldName: 'specialistAvatar',
              asImage: true
            }
            this.flowSpecialistAuditForm.specialistAvatar.impl.fileList = this.parseUploadData(dataForm.specialistAvatar, specialistAvatarDownloadParams);
          } else {
            dataForm.specialistAvatar = undefined
          }

          if (dataForm.educationalFile) {
            let str = JSON.parse(dataForm.educationalFile)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.educationalFile = JSON.stringify(str)

            let educationalFileDownloadParams = {
              id: dataForm.id,
              fieldName: 'educationalFile',
              asImage: true
            }
            this.flowSpecialistAuditForm.educationalFile.impl.fileList = this.parseUploadData(dataForm.educationalFile, educationalFileDownloadParams);
          } else {
            dataForm.educationalFile = undefined
          }
          if (dataForm.degreeFiles) {
            let str = JSON.parse(dataForm.degreeFiles)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.degreeFiles = JSON.stringify(str)

            let degreeFilesDownloadParams = {
              id: dataForm.id,
              fieldName: 'degreeFiles',
              asImage: true
            }
            this.flowSpecialistAuditForm.degreeFiles.impl.fileList = this.parseUploadData(dataForm.degreeFiles, degreeFilesDownloadParams);
          } else {
            dataForm.degreeFiles = undefined
          }
          if (dataForm.positionalFiles) {
            let str = JSON.parse(dataForm.positionalFiles)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.positionalFiles = JSON.stringify(str)

            let positionalFilesDownloadParams = {
              id: dataForm.id,
              fieldName: 'positionalFiles',
              asImage: true
            }
            this.flowSpecialistAuditForm.positionalFiles.impl.fileList = this.parseUploadData(dataForm.positionalFiles, positionalFilesDownloadParams);
          } else {
            dataForm.positionalFiles = undefined
          }
          if (dataForm.servicePhoto) {
            let str = JSON.parse(dataForm.servicePhoto)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.servicePhoto = JSON.stringify(str)

            let servicePhotoDownloadParams = {
              id: dataForm.id,
              fieldName: 'servicePhoto',
              asImage: true
            }
            this.flowSpecialistAuditForm.servicePhoto.impl.fileList = this.parseUploadData(dataForm.servicePhoto, servicePhotoDownloadParams);
          } else {
            dataForm.servicePhoto = undefined
          }
          if (dataForm.idPhoto) {
            let str = JSON.parse(dataForm.idPhoto)
            if (str[0].name === undefined) {
              str[0].name = str[0].filename
            }
            dataForm.idPhoto = JSON.stringify(str)

            let idPhotoDownloadParams = {
              id: dataForm.id,
              fieldName: 'idPhoto',
              asImage: true
            }
            this.flowSpecialistAuditForm.idPhoto.impl.fileList = this.parseUploadData(dataForm.idPhoto, idPhotoDownloadParams);
          } else {
            dataForm.idPhoto = undefined
          }

          let otherFilesDownloadParams = {
            id: dataForm.id,
            fieldName: 'otherFiles',
            asImage: false
          }

          this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = dataForm.specialistMemberList
          this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = dataForm.specialistMemberList.length
          this.flowSpecialistAuditForm.otherFiles.impl.fileList = this.parseUploadData(dataForm.otherFiles, otherFilesDownloadParams);

          this.formData.Specialist = dataForm
          this.flowSpecialistAuditForm.stationIds.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.hotFlag.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.starFlag.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange(true).catch(e => {});
          // this.flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.identity.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.isDistrict.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.education.impl.onVisibleChange(true).catch(e => {});
          // 获取一对多、多对多数据
          this.refreshFlowSpecialistAuditForm(true);
          this.showSecond = true
        }).catch(e => {});

        if (this.isDraft) {
          that.rules['Specialist.servicePhoto'] = [{ required: true, message: '请上传服务单位营业执照', trigger: 'change' }]
        }

        let params2 = {
          specialistHisDtoFilter: {
            processInstanceId: this.processInstanceId
          }
        }
        // 获取服务签约信息
        SpecialistHisController.list(this, params2).then(res => {
          if (res.data.dataList.length > 0) {
            that.formData.SpecialistHis = res.data.dataList[0]
            let contractFilesDownloadParams = {
              id: that.formData.SpecialistHis.id,
              fieldName: 'contractFiles',
              asImage: false
            }

            let attachedFilesDownloadParams = {
              id: that.formData.SpecialistHis.id,
              fieldName: 'attachedFiles',
              asImage: false
            }

            that.signContractWin.serviceAreaId.impl.onVisibleChange(true).catch(e => {});
            that.signContractWin.contractFiles.impl.fileList =
                that.parseUploadData(that.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
            that.signContractWin.attachedFiles.impl.fileList =
                that.parseUploadData(that.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
          }
        })
      } else {
        // 启动流程

        let params = {
          specialistInfoDtoFilter: {
          },
          userId: 'userId',
          orderParam: [
            {
              fieldName: 'createTime',
              asc: false
            }
          ]
        }
        this.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});
        that.rules['Specialist.servicePhoto'] = [{ required: true, message: '请上传服务单位营业执照', trigger: 'change' }]

        // if (this.taskId && this.isRuntime) {

        SpecialistInfoController.list(this, params, null, {showMask: false}).then(data => {
          // console.log(JSON.stringify(data))
          let dataForm = {}
          if (data.data.dataList.length > 0) {
            dataForm = {...data.data.dataList[0]}
            let id = data.data.dataList[0].id
            SpecialistInfoController.view(this, {id: id, flag: '1'}, null, {showMask: false}).then(res => {
              // console.log(JSON.stringify(data))
              // dataForm = data.data
              if (dataForm.specialistMemberList && res.data.specialistType === '2') {
                dataForm.specialistMemberList = res.data.specialistMemberList
                that.flowSpecialistAuditForm.SpecialistMember.impl.dataList = res.data.specialistMemberList
                that.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = res.data.specialistMemberList.length
                // that.memberList = that.form.specialistMemberList
                // for(var i= 0;i<that.form.specialistMemberList.length;i++){
                //   that.memberList[i].specialistAvatar = JSON.parse(that.form.specialistMemberList[i].specialistAvatar)
                //   that.memberList[i].member = '团队成员' + (i + 1)
                // }
              }
            })

            that.showSecond = true
            // 很重要
            dataForm.auditStatus = '0'
            dataForm.filingPassed = null
            dataForm.subscribeMessage = null

            if (dataForm.specialistAvatar) {
              let str = JSON.parse(dataForm.specialistAvatar)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.specialistAvatar = JSON.stringify(str)

              let specialistAvatarDownloadParams = {
                id: dataForm.id,
                fieldName: 'specialistAvatar',
                asImage: true
              }
              this.flowSpecialistAuditForm.specialistAvatar.impl.fileList = this.parseUploadData(dataForm.specialistAvatar, specialistAvatarDownloadParams);
            } else {
              this.formData.Specialist.specialistAvatar = undefined
            }

            if (dataForm.educationalFile) {
              let str = JSON.parse(dataForm.educationalFile)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.educationalFile = JSON.stringify(str)

              let educationalFileDownloadParams = {
                id: this.formData.Specialist.id,
                fieldName: 'educationalFile',
                asImage: true
              }
              this.flowSpecialistAuditForm.educationalFile.impl.fileList = this.parseUploadData(dataForm.educationalFile, educationalFileDownloadParams);
            } else {
              this.formData.Specialist.educationalFile = undefined
            }

            if (dataForm.degreeFiles) {
              let str = JSON.parse(dataForm.degreeFiles)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.degreeFiles = JSON.stringify(str)

              let degreeFilesDownloadParams = {
                id: dataForm.id,
                fieldName: 'degreeFiles',
                asImage: true
              }
              this.flowSpecialistAuditForm.degreeFiles.impl.fileList = this.parseUploadData(dataForm.degreeFiles, degreeFilesDownloadParams);
            } else {
              dataForm.degreeFiles = undefined
            }
            if (dataForm.positionalFiles) {
              let str = JSON.parse(dataForm.positionalFiles)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.positionalFiles = JSON.stringify(str)

              let positionalFilesDownloadParams = {
                id: dataForm.id,
                fieldName: 'positionalFiles',
                asImage: true
              }
              this.flowSpecialistAuditForm.positionalFiles.impl.fileList = this.parseUploadData(dataForm.positionalFiles, positionalFilesDownloadParams);
            } else {
              dataForm.positionalFiles = undefined
            }
            if (dataForm.servicePhoto) {
              let str = JSON.parse(dataForm.servicePhoto)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.servicePhoto = JSON.stringify(str)

              let servicePhotoDownloadParams = {
                id: dataForm.id,
                fieldName: 'servicePhoto',
                asImage: true
              }
              this.flowSpecialistAuditForm.servicePhoto.impl.fileList = this.parseUploadData(dataForm.servicePhoto, servicePhotoDownloadParams);
            } else {
              dataForm.servicePhoto = undefined
            }
            if (dataForm.idPhoto) {
              let str = JSON.parse(dataForm.idPhoto)
              if (str[0].name === undefined) {
                str[0].name = str[0].filename
              }
              dataForm.idPhoto = JSON.stringify(str)

              let idPhotoDownloadParams = {
                id: dataForm.id,
                fieldName: 'idPhoto',
                asImage: true
              }
              this.flowSpecialistAuditForm.idPhoto.impl.fileList = this.parseUploadData(dataForm.idPhoto, idPhotoDownloadParams);
            } else {
              dataForm.idPhoto = undefined
            }

            that.flowSpecialistAuditForm.gender.impl.onVisibleChange(true).catch(e => {});

            let otherFilesDownloadParams = {
              id: dataForm.id,
              fieldName: 'otherFiles',
              asImage: false
            }
            if (!dataForm.specialistMemberList) {
              dataForm.specialistMemberList = []
            }
            that.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.SpecialistMember.impl.dataList = dataForm.specialistMemberList
            that.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = dataForm.specialistMemberList.length
            that.flowSpecialistAuditForm.otherFiles.impl.fileList = that.parseUploadData(dataForm.otherFiles, otherFilesDownloadParams);
            that.flowSpecialistAuditForm.stationIds.impl.onVisibleChange(true).catch(e => {});

            that.flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.identity.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.isDistrict.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
            that.flowSpecialistAuditForm.education.impl.onVisibleChange(true).catch(e => {});

            that.formData.Specialist = dataForm

            let params2 = {
              specialistHisDtoFilter: {
                specialistInfoId: dataForm.id
              }
            }
            // 获取服务签约信息
            SpecialistHisController.list(this, params2).then(res => {
              if (res.data.dataList.length > 0) {
                that.formData.SpecialistHis = res.data.dataList[0]
                let contractFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'contractFiles',
                  asImage: false
                }

                let attachedFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'attachedFiles',
                  asImage: false
                }

                that.signContractWin.serviceAreaId.impl.onVisibleChange(true).catch(e => {});
                that.signContractWin.contractFiles.impl.fileList =
                  that.parseUploadData(that.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
                that.signContractWin.attachedFiles.impl.fileList =
                  that.parseUploadData(that.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
                that.formData.SpecialistHis.id = null
                that.formData.SpecialistHis.specialistInfoId = null
                that.formData.SpecialistHis.specialId = null
              }
            })
            // that.formData.SpecialistHis.serviceObjectName = that.formData.Specialist.serviceObjectName
            // that.formData.SpecialistHis.serviceAreaId = that.formData.Specialist.serviceAreaId
            // that.signContractWin.serviceAreaId.impl.onVisibleChange(true).catch(e => {});
            // that.formData.SpecialistHis.contactsUserTel = that.formData.Specialist.contactsUserTel
            // that.formData.SpecialistHis.serviceUserRequirement = that.formData.Specialist.serviceUserRequirement
            // that.formData.SpecialistHis.contactsUser = that.formData.Specialist.contactsUser
            // that.formData.SpecialistHis.serviceObjectName = that.formData.Specialist.serviceObjectName
            // that.formData.SpecialistHis.mainBusiness = that.formData.Specialist.mainBusiness
            // that.formData.SpecialistHis.signYear = that.formData.Specialist.signYear
            // that.formData.SpecialistHis.serviceType = that.formData.Specialist.serviceType
            // that.formData.SpecialistHis.serviceContent = that.formData.Specialist.serviceContent
            // that.formData.SpecialistHis.serviceAddress = that.formData.Specialist.serviceAddress
            // that.formData.SpecialistHis.signYearStart = that.formData.Specialist.signYearStart
            // that.formData.SpecialistHis.signYearEnd = that.formData.Specialist.signYearEnd

            that.formData.Specialist.id = null
            // that.signContractWin.signYear.impl.onVisibleChange(true).catch(e => {});
            //   }
            // })
          }
        })
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
       * 拨付渠道下拉数据获取函数
       */
    loadAppropriateChannelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAppropriateChannelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 拨付渠道选中值改变
       */
    onAppropriateChannelValueChange (value) {
    },
    /**
       * 类型下拉数据获取函数
       */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          let list = res.getList().concat();
          list.pop()
          resolve(list);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 类型选中值改变
       */
    onSpecialistTypeValueChange (value) {
      if (value === '2') {
        // 团队
        this.myLabel.specialistNameLabel = '发起人姓名';
        this.myLabel.specialistSpecialLabel = '团队简介';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: true, message: '请输入团队名称', trigger: 'change' }]
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.birthday')
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      } else if (value === '3') {
        // 法人
        this.myLabel.specialistNameLabel = '法人名称';
        this.myLabel.specialistSpecialLabel = '法人简介';
        this.rules['Specialist.identityCardNo'] = [{ required: true, message: '请输入法人识别号', trigger: 'change' }]
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: false, message: '请选择专业领域', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.industryId')
        this.rules['Specialist.mobilePhone'] = [{ required: false, message: '请输入联系电话', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.mobilePhone')
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.birthday')
      } else {
        this.myLabel.specialistNameLabel = '姓名';
        this.myLabel.specialistSpecialLabel = '专家简介、技术特长及服务内容（不超过100字）';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.flowSpecialistAuditForm.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: true, message: '请选择出生日期', trigger: 'change' }]
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      }

      // 个人才要填生日
      this.myFlag.birthdayFlag = true;
      // if (value !== '1') {
      //   this.myFlag.birthdayFlag = false;
      // }
    },
    /**
       * 性别下拉数据获取函数
       */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 性别选中值改变
       */
    onGenderValueChange (value) {
    },
    /**
       * 专业领域下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专业领域选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.Specialist.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 所在地区下拉数据获取函数
       */
    loadServiceAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 所在地区选中值改变
       */
    onServiceAreaIdValueChange (value) {
      this.formData.SpecialistHis.serviceAreaId = Array.isArray(value) ? value[value.length - 1] : undefined;

      const checkedNode = this.$refs['serviceAreaIdCas'].getCheckedNodes();
      let address = ''
      if (checkedNode && checkedNode.length > 0) {
        let arr = checkedNode[0].pathLabels;

        arr.forEach((item) => {
          address = address + item
        })
        this.formData.SpecialistHis.serviceAddress = address
      }
    },
    /**
       * 学位下拉数据获取函数
       */
    loadDegreeLevelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDegreeLevelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学位选中值改变
       */
    onDegreeLevelValueChange (value) {
    },
    /**
       * 学历下拉数据获取函数
       */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学历选中值改变
       */
    onEducationValueChange (value) {
    },
    /**
       * 职称下拉数据获取函数
       */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 职称选中值改变
       */
    onSpecialistTitleIdValueChange (value) {
    },

    /**
       * 派驻站点下拉数据获取函数
       */
    loadStationIdsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 派驻站点选中值改变
       */
    onStationIdsValueChange (value) {
    },
    /**
       * 地区ID下拉数据获取函数
       */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 地区ID选中值改变
       */
    onAreaIdValueChange (value) {
      this.formData.Specialist.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 热门专家下拉数据获取函数
       */
    loadHotFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 热门专家选中值改变
       */
    onHotFlagValueChange (value) {
    },
    /**
       * 明星专家下拉数据获取函数
       */
    loadStarFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 明星专家选中值改变
       */
    onStarFlagValueChange (value) {
    },
    /**
       * 证件类型下拉数据获取函数
       */
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 证件类型选中值改变
       */
    onDocumentTypeValueChange (value) {
    },
    /**
       * 身份下拉数据获取函数
       */
    loadIdentityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIdentityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 身份选中值改变
       */
    onIdentityValueChange (value) {
    },
    /**
       * 区级下拉数据获取函数
       */
    loadIsDistrictDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDistrictDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 区级选中值改变
       */
    onIsDistrictValueChange (value) {
    },
    /**
       * 更新专家认证审核表单
       */
    refreshFlowSpecialistAuditForm (reloadData = false) {
      if (!this.flowSpecialistAuditForm.isInit) {
        // 初始化下拉数据
        this.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});
        this.flowSpecialistAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
        this.flowSpecialistAuditForm.hotFlag.impl.onVisibleChange(true).catch(e => {});
        this.flowSpecialistAuditForm.starFlag.impl.onVisibleChange(true).catch(e => {});
      }
      this.flowSpecialistAuditForm.isInit = true;
    },
    /**
       * 照片上传成功
       */
    onSpecialistAvatarUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
        this.formData.Specialist.specialistAvatar = this.fileListToJson(this.flowSpecialistAuditForm.specialistAvatar.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除照片
       */
    onSpecialistAvatarRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
      this.formData.Specialist.specialistAvatar = this.fileListToJson(this.flowSpecialistAuditForm.specialistAvatar.impl.fileList);
    },
    /**
       * 证件照上传成功
       */
    onIdPhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.idPhoto.impl.onFileChange(file, fileList);
        this.formData.Specialist.idPhoto = this.fileListToJson(this.flowSpecialistAuditForm.idPhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除证件照
       */
    onIdPhotoAvatarRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.idPhoto.impl.onFileChange(file, fileList);
      this.formData.Specialist.idPhoto = this.fileListToJson(this.flowSpecialistAuditForm.idPhoto.impl.fileList);
    },
    /**
       * 学历资料上传成功
       */
    onEducationalFileUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.educationalFile.impl.onFileChange(file, fileList);
        this.formData.Specialist.educationalFile = this.fileListToJson(this.flowSpecialistAuditForm.educationalFile.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除学历资料
       */
    onEducationalFileRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.educationalFile.impl.onFileChange(file, fileList);
      this.formData.Specialist.educationalFile = this.fileListToJson(this.flowSpecialistAuditForm.educationalFile.impl.fileList);
    },
    /**
       * 学位资料上传成功
       */
    onDegreeFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.degreeFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.degreeFiles = this.fileListToJson(this.flowSpecialistAuditForm.degreeFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除学位资料
       */
    onDegreeFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.degreeFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.degreeFiles = this.fileListToJson(this.flowSpecialistAuditForm.degreeFiles.impl.fileList);
    },
    /**
       * 职称资料上传成功
       */
    onPositionalFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.positionalFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.positionalFiles = this.fileListToJson(this.flowSpecialistAuditForm.positionalFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除职称资料
       */
    onPositionalFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.positionalFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.positionalFiles = this.fileListToJson(this.flowSpecialistAuditForm.positionalFiles.impl.fileList);
    },

    /**
       * 服务单位营业执照
       */
    onServicePhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.servicePhoto.impl.onFileChange(file, fileList);
        this.formData.Specialist.servicePhoto = this.fileListToJson(this.flowSpecialistAuditForm.servicePhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除服务单位营业执照
       */
    onServicePhotoRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.servicePhoto.impl.onFileChange(file, fileList);
      this.formData.Specialist.servicePhoto = this.fileListToJson(this.flowSpecialistAuditForm.servicePhoto.impl.fileList);
    },

    /**
       * 其他附件上传成功
       */
    onOtherFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.otherFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.otherFiles = this.fileListToJson(this.flowSpecialistAuditForm.otherFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除其他附件
       */
    onOtherFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.otherFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.otherFiles = this.fileListToJson(this.flowSpecialistAuditForm.otherFiles.impl.fileList);
    },
    deleteOtherFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onOtherFilesRemoveFile(file, fileList)
    },
    /**
       * 更新团队成员列表
       */
    refreshSpecialistMemberList (reloadData = false) {
      this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
      this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
      this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
    },
    /**
       * 删除
       */
    onDeleteClick (row, index) {
      this.$confirm('是否删除?').then(res => {
        index = (this.currentPage - 1) * this.PageSize + index
        this.formData.Specialist.specialistMemberList.splice(index, 1);
        console.log('删除row', row, index)
        this.$message.success('删除成功');
        this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
      }).catch(e => {});
    },
    /**
       * 编辑
       */
    onSpecialistMemberEditClick (row, index) {
      let params = {
        specialistMemberForm: row
      };
      console.log('indexindexindexindexindex', this.currentPage, index)
      this.$dialog.show('编辑', specialistMemberEdit, {
        area: '800px'
      }, params).then(res => {
        if (index === -1) {
          this.$message.success('编辑失败');
        } else {
          index = (parseInt(this.currentPage) - 1) * this.PageSize + index
          this.formData.Specialist.specialistMemberList[index] = res.specialistMemberDto
          this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
          this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
          this.refreshSpecialistMemberList();
          // this.budgetDetailPage.BudgetDetail.impl.refreshTable();
          this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
          this.formData.Specialist.specialistMemberList.splice(1, 0);
        }
      }).catch(e => {});
    },
    /**
       * 新增
       */
    addSpecialistMember () {
      let params = {};

      this.$dialog.show('新增', specialistMemberForm, {
        area: '800px'
      }, params).then(res => {
        console.log('res66666', res, this.formData.Specialist.specialistMemberList)
        var size = this.formData.Specialist.specialistMemberList.length
        console.log('sizesizesizesize', size, this.formData.Specialist.specialistMemberList)
        this.formData.Specialist.specialistMemberList[size] = res.specialistMemberDto

        this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        console.log('this.budgetDetailPage.BudgetDetail.impl.dataList', this.flowSpecialistAuditForm.SpecialistMember.impl.dataList)
        this.refreshSpecialistMemberList();
        this.formData.Specialist.specialistMemberList.splice(1, 0);
      }).catch(e => {});
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
      this.onSpecialistTypeValueChange('1')
    },
    handleClick (tab, event) {
      // console.log(tab, event);
    },
    /**
       * 移除其他附件
       */
    onAttachedFilesRemoveFile (file, fileList) {
      this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    /**
       * 其他附件上传成功
       */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 三方协议书上传成功
       */
    onContractFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除三方协议书
       */
    onContractFilesRemoveFile (file, fileList) {
      this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    },
    ...mapGetters(['getUserInfo'])
  },
  mounted () {
    // console.log(this.getUserInfo)
    // 初始化页面数据
    this.formInit();
  }
}
</script>
